import React, { useEffect, useState } from 'react';

import { cn } from 'lib/helpers/utility';

import Avatar from 'components/shared/Avatar/Avatar';
import Button from 'components/shared/Button/Button';
import Icon from 'components/shared/Icon/Icon';

import backgroundImage from './../assets/glass.svg';

import './../styles/intro-animation.scss';

const Intro = ({ title, description, onSkip, onEndIntro, consultant }) => {
  const [showContent, setShowContent] = useState({
    welcome: true,
    orchestartor: false,
    understanding: false
  });

  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowContent({
        welcome: false,
        orchestartor: true,
        understanding: false
      });
      setAnimate(true);
    }, 5000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <div className="relative h-screen w-full overflow-hidden">
        <div className="animate-svg-top absolute -bottom-80 -right-28 z-[9999] opacity-50">
          <svg
            width="600"
            height="788"
            viewBox="0 0 1153 1517"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M1080.33 492.928C1176.58 589.179 1176.58 744.855 1079.5 841.943C1077.82 843.617 1063.59 857.845 958.973 962.466C886.157 1035.28 769.819 1151.62 584.013 1337.43L495.295 1426.14C381.468 1544.99 195.662 1544.99 83.5084 1432.84C-29.4819 1319.85 -29.4819 1132.37 94.3888 1020.22C-120.711 602.571 387.326 183.251 753.917 471.167C851.842 395.004 990.778 403.373 1080.33 492.928Z"
              fill="white"
            />
            <path
              d="M825.665 1159.35C1005.08 979.938 1005.78 688.317 826.14 508.68C646.502 329.042 354.881 329.738 175.465 509.154C-3.95102 688.57 -4.64692 980.191 174.991 1159.83C354.628 1339.47 645.374 1339.65 825.665 1159.35Z"
              fill="white"
            />
            <path
              d="M945.27 337.352C869.423 261.505 746.266 261.089 670.477 336.877C594.688 412.666 595.105 535.823 670.952 611.67C746.798 687.516 869.956 687.933 945.744 612.144C1021.53 536.356 1021.49 413.568 945.27 337.352Z"
              fill="white"
            />
            <path
              d="M928.184 101.951C880.584 54.3507 803.371 54.01 755.905 101.476C708.439 148.943 708.779 226.155 756.379 273.756C803.98 321.356 881.192 321.696 928.659 274.23C976.125 226.764 976.016 149.783 928.184 101.951Z"
              fill="white"
            />
            <path
              d="M788.652 218.702C723.267 153.317 617.126 152.929 551.827 218.228C486.529 283.526 486.917 389.667 552.302 455.052C617.687 520.437 723.828 520.826 789.127 455.527C854.426 390.228 854.356 284.406 788.652 218.702Z"
              fill="white"
            />
            <path
              d="M1079.5 841.935C1175.75 745.684 1176.59 589.172 1080.34 492.921C984.086 396.67 827.574 397.507 731.323 493.758C635.072 590.009 634.235 746.521 730.486 842.772C826.737 939.023 983.249 938.186 1079.5 841.935Z"
              fill="white"
            />
            <path
              d="M901.369 221.262C951.779 271.672 1033.77 271.808 1084.32 221.262C1134.87 170.716 1134.73 88.7207 1084.32 38.3107C1033.91 -12.0994 951.915 -12.2353 901.369 38.3107C850.823 88.8567 850.713 170.606 901.369 221.262Z"
              fill="white"
            />
            <path
              d="M720.241 495.777C502.41 495.777 324.958 672.385 324.958 890.484C324.958 1108.58 502.411 1285.19 720.241 1285.19C938.072 1285.19 1115.52 1108.58 1115.52 890.484C1115.52 672.384 939.135 495.777 720.241 495.777Z"
              fill="white"
            />
            <path
              d="M791.019 557.088C871.835 637.904 1003.29 638.121 1084.32 557.088C1165.35 476.054 1165.14 344.602 1084.32 263.786C1003.51 182.97 872.052 182.752 791.019 263.786C709.985 344.819 709.809 475.878 791.019 557.088Z"
              fill="white"
            />
          </svg>
        </div>
        <div className="animate-svg-bottom absolute -left-28 -top-96 z-[9999] rotate-180 opacity-50">
          <svg
            width="600"
            height="788"
            viewBox="0 0 1153 1517"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M1080.33 492.928C1176.58 589.179 1176.58 744.855 1079.5 841.943C1077.82 843.617 1063.59 857.845 958.973 962.466C886.157 1035.28 769.819 1151.62 584.013 1337.43L495.295 1426.14C381.468 1544.99 195.662 1544.99 83.5084 1432.84C-29.4819 1319.85 -29.4819 1132.37 94.3888 1020.22C-120.711 602.571 387.326 183.251 753.917 471.167C851.842 395.004 990.778 403.373 1080.33 492.928Z"
              fill="white"
            />
            <path
              d="M825.665 1159.35C1005.08 979.938 1005.78 688.317 826.14 508.68C646.502 329.042 354.881 329.738 175.465 509.154C-3.95102 688.57 -4.64692 980.191 174.991 1159.83C354.628 1339.47 645.374 1339.65 825.665 1159.35Z"
              fill="white"
            />
            <path
              d="M945.27 337.352C869.423 261.505 746.266 261.089 670.477 336.877C594.688 412.666 595.105 535.823 670.952 611.67C746.798 687.516 869.956 687.933 945.744 612.144C1021.53 536.356 1021.49 413.568 945.27 337.352Z"
              fill="white"
            />
            <path
              d="M928.184 101.951C880.584 54.3507 803.371 54.01 755.905 101.476C708.439 148.943 708.779 226.155 756.379 273.756C803.98 321.356 881.192 321.696 928.659 274.23C976.125 226.764 976.016 149.783 928.184 101.951Z"
              fill="white"
            />
            <path
              d="M788.652 218.702C723.267 153.317 617.126 152.929 551.827 218.228C486.529 283.526 486.917 389.667 552.302 455.052C617.687 520.437 723.828 520.826 789.127 455.527C854.426 390.228 854.356 284.406 788.652 218.702Z"
              fill="white"
            />
            <path
              d="M1079.5 841.935C1175.75 745.684 1176.59 589.172 1080.34 492.921C984.086 396.67 827.574 397.507 731.323 493.758C635.072 590.009 634.235 746.521 730.486 842.772C826.737 939.023 983.249 938.186 1079.5 841.935Z"
              fill="white"
            />
            <path
              d="M901.369 221.262C951.779 271.672 1033.77 271.808 1084.32 221.262C1134.87 170.716 1134.73 88.7207 1084.32 38.3107C1033.91 -12.0994 951.915 -12.2353 901.369 38.3107C850.823 88.8567 850.713 170.606 901.369 221.262Z"
              fill="white"
            />
            <path
              d="M720.241 495.777C502.41 495.777 324.958 672.385 324.958 890.484C324.958 1108.58 502.411 1285.19 720.241 1285.19C938.072 1285.19 1115.52 1108.58 1115.52 890.484C1115.52 672.384 939.135 495.777 720.241 495.777Z"
              fill="white"
            />
            <path
              d="M791.019 557.088C871.835 637.904 1003.29 638.121 1084.32 557.088C1165.35 476.054 1165.14 344.602 1084.32 263.786C1003.51 182.97 872.052 182.752 791.019 263.786C709.985 344.819 709.809 475.878 791.019 557.088Z"
              fill="white"
            />
          </svg>
        </div>
        <div className="absolute z-[9999] h-full w-full backdrop-blur-[30px]"></div>

        <div>
          <svg
            width="83"
            height="347"
            viewBox="0 0 83 347"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M-296.765 -689.176C-416.723 -809.134 -611.426 -809.876 -731.192 -690.11C-850.957 -570.345 -850.216 -375.642 -730.257 -255.683C-610.299 -135.725 -415.596 -134.984 -295.831 -254.749C-176.065 -374.515 -176.221 -568.632 -296.765 -689.176Z"
              fill="white"
            />
            <path
              d="M-7.14685 -791.944C-75.6208 -860.418 -186.581 -861.02 -254.724 -792.878C-322.866 -724.735 -322.263 -613.775 -253.789 -545.301C-185.315 -476.827 -74.3551 -476.224 -6.21265 -544.367C61.9298 -612.509 61.6613 -723.136 -7.14685 -791.944Z"
              fill="white"
            />
            <path
              d="M-586.041 -270.891C-727.495 -412.344 -957.124 -413.181 -1098.4 -271.909C-1239.67 -130.637 -1238.83 98.9917 -1097.38 240.445C-955.923 381.899 -726.295 382.736 -585.022 241.464C-443.75 100.192 -443.897 -128.747 -586.041 -270.891Z"
              fill="white"
            />
            <path
              d="M-23.9646 -513.537C-150.101 -639.673 -354.853 -640.431 -480.814 -514.471C-606.774 -388.511 -606.016 -183.759 -479.879 -57.6224C-353.743 68.5141 -148.991 69.2722 -23.0305 -56.688C102.93 -182.648 102.787 -386.785 -23.9646 -513.537Z"
              fill="white"
            />
            <path
              d="M-321.988 -221.116C-415.689 -314.817 -567.683 -315.488 -661.121 -222.05C-754.559 -128.612 -753.888 23.3819 -660.187 117.083C-566.485 210.785 -414.491 211.455 -321.054 118.018C-227.616 24.5798 -227.829 -126.957 -321.988 -221.116Z"
              fill="white"
            />
            <path
              d="M57.691 -586.478C24.8341 -619.335 -28.4635 -619.57 -61.228 -586.806C-93.9924 -554.042 -93.7573 -500.744 -60.9004 -467.887C-28.0435 -435.03 25.2542 -434.795 58.0186 -467.559C90.7831 -500.324 90.7083 -553.461 57.691 -586.478Z"
              fill="white"
            />
          </svg>
        </div>
        <div
          className="absolute bottom-0 left-0 top-0 h-full w-full"
          style={{
            background:
              'linear-gradient(223.714deg, rgba(239,239,239,0.6) 0%, rgba(255,255,255,0.08) 100%)'
          }}></div>
      </div>
      <div
        className={cn(
          'animate-zoomIn-image url(${backgroundImage}) fixed left-0 top-0 z-[999] flex h-screen w-screen flex-col items-center justify-center bg-opacity-50 bg-cover bg-center text-center text-white transition-all duration-700'
        )}
        style={{ background: `url(${backgroundImage})` }}></div>
      <div
        className={cn(
          'animate-background fixed left-0 top-0 z-[999] flex h-screen w-screen flex-col items-center justify-center bg-cover bg-center text-center text-white transition-all duration-700',
          showContent.welcome ? 'bg-opacity-0' : 'bg-opacity-100'
        )}
        style={{ background: '#B0EAFF' }}></div>
      {showContent.welcome && (
        <div
          className={`absolute bottom-0 left-0 right-0 top-0 z-[99999] flex flex-col items-center justify-center gap-2 text-center transition-all duration-500 ${
            showContent.welcome ? 'opacity-100' : 'opacity-0'
          }`}>
          <p className="text-4xl text-primary-300">Welcome to</p>
          <h1 className="mb-6 text-7xl font-600 text-primary-900">{title}</h1>
          <p className="text-2xl text-primary-900">{description}</p>
        </div>
      )}
      <div
        className={`absolute bottom-0 left-0 right-0 top-0 z-[99999] flex flex-col items-center justify-center gap-2 text-center transition-transform duration-500 ${
          showContent.orchestartor ? 'opacity-100' : 'opacity-0'
        }`}>
        <div className="mb-10 mt-16 flex h-full w-full flex-col justify-between px-20">
          <div className=" flex w-full justify-center">
            <Icon
              size={250}
              icon="logo-white"
              className={cn(
                '-translate-y-32 text-center transition duration-[1200ms]',
                animate && 'translate-y-0'
              )}
            />
          </div>
          <div
            className={cn(
              'mx-auto flex max-w-[70%] flex-col items-center gap-4 opacity-0 transition duration-500',
              showContent.orchestartor && 'opacity-100'
            )}>
            <p className="text-4xl font-700 text-primary-900">Myriad Motion</p>
            <p className="text-2xl font-500 text-primary-900">
              An Orchestrated Onboarding Experience
            </p>
            <p className="my-4 text-base text-primary-900">
              To get the most out of Myriad Health, we recommend completing our Onboarding Wizard.
              This process will help you set up your practice efficiently and ensure you have access
              to all the features and tools Myriad Health offers.
            </p>

            <Button
              highlighted
              size="large"
              className="border-rotate w-[300px] !text-lg font-light"
              text="Start Now"
              onClick={onEndIntro}
            />
          </div>
          <div
            className={cn(
              'flex translate-y-32 items-end justify-between text-center transition duration-[1200ms]',
              animate && 'translate-y-0'
            )}>
            {consultant && (
              <div className="flex flex-col gap-4">
                <p className="text-sm text-primary-700">Your Myriad Consultant:</p>
                <div className="flex w-fit items-center gap-2 rounded-full bg-white p-2 pr-4 text-primary-900">
                  <Avatar
                    firstName={consultant.firstName}
                    lastName={consultant.lastName}
                    id={consultant.id}
                    image={consultant.profile_picture}
                    isSquare={false}
                  />
                  <span>{`${consultant.firstName ?? ''} ${consultant.lastName ?? ''}`.trim()}</span>
                </div>
              </div>
            )}
            <div className="flex flex-col items-end gap-2">
              <Button
                color="white"
                onClick={onSkip}
                variant="link"
                text="Continue to practice dashboard"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Intro;
